import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  User,
  Activity,
  CreditCard,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Clock,
  BookOpen,
  DollarSign,
  RefreshCw,
  Eye,
  CheckCircle,
  XCircle,
  RotateCcw,
} from "lucide-react";
// import UserImage01 from "../../../../assets/images/image-user-01.webp";
import UserImage01 from "../../../assets/images/image-user-01.webp";
import { useParams } from "react-router-dom";
import Transaction from "../transaction/Transaction";
const UserDetailsPage = () => {
  const [activeTab, setActiveTab] = useState("basic");
  const { id } = useParams();
  console.log(id);
  // Mock user data
  const userData = {
    basic: {
      fullName: "Sarah Johnson",
      email: "sarah.johnson@example.com",
      phone: "+1 (555) 123-4567",
      shippingAddress: "123 Main St, Apt 4B\nNew York, NY 10001\nUnited States",
      billingAddress: "456 Oak Avenue\nBrooklyn, NY 11201\nUnited States",
    },
    activity: {
      accountCreated: "March 15, 2023",
      lastLogin: "2 hours ago",
      coloringBooksCreated: 47,
      totalSessions: 156,
      averageSessionTime: "23 minutes",
    },
    payments: {
      lastPayment: { date: "Dec 5, 2024", amount: "$29.99" },
      totalPayments: "$347.86",
      transactions: [
        {
          id: "txn_1234567890",
          date: "Dec 5, 2024",
          time: "2:34 PM",
          amount: "$29.99",
          status: "Success",
          method: "Visa •••• 4242",
          stripeId: "pi_1234567890",
        },
        {
          id: "txn_0987654321",
          date: "Nov 5, 2024",
          time: "1:15 PM",
          amount: "$19.99",
          status: "Success",
          method: "Mastercard •••• 8888",
          stripeId: "pi_0987654321",
        },
        {
          id: "txn_1122334455",
          date: "Oct 12, 2024",
          time: "4:22 PM",
          amount: "$39.99",
          status: "Failed",
          method: "Visa •••• 4242",
          stripeId: "pi_1122334455",
        },
        {
          id: "txn_5566778899",
          date: "Sep 20, 2024",
          time: "11:30 AM",
          amount: "$29.99",
          status: "Refunded",
          method: "PayPal",
          stripeId: "pi_5566778899",
        },
        {
          id: "txn_9988776655",
          date: "Aug 15, 2024",
          time: "3:45 PM",
          amount: "$49.99",
          status: "Success",
          method: "Visa •••• 4242",
          stripeId: "pi_9988776655",
        },
      ],
    },
  };

  const tabs = [
    { id: "basic", label: "Basic Details", icon: User },
    { id: "activity", label: "Activity", icon: Activity },
    { id: "payments", label: "Payments", icon: CreditCard },
  ];

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const tabContentVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      x: -20,
      transition: { duration: 0.3 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Success":
        return "text-green-600 bg-green-50";
      case "Failed":
        return "text-red-600 bg-red-50";
      case "Refunded":
        return "text-orange-600 bg-orange-50";
      default:
        return "text-gray-600 bg-gray-50";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Success":
        return <CheckCircle className="w-4 h-4" />;
      case "Failed":
        return <XCircle className="w-4 h-4" />;
      case "Refunded":
        return <RotateCcw className="w-4 h-4" />;
      default:
        return <Clock className="w-4 h-4" />;
    }
  };

  const renderBasicDetails = () => (
    <motion.div
      key="basic"
      variants={tabContentVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="grid grid-cols-1 lg:grid-cols-3 gap-8"
    >
      {/* Profile Image Section */}
      <motion.div
        variants={cardVariants}
        className="lg:col-span-1 flex flex-col items-center"
      >
        <motion.div
          className="relative mb-6"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          <div className="relative w-48 h-48 rounded-full overflow-hidden ring-4 ring-white shadow-2xl">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500"></div>
            <img
              src={UserImage01}
              alt="Profile"
              className="w-full h-full object-cover relative z-10"
            />
            <motion.div
              className="absolute inset-0 bg-gradient-to-br from-blue-400/20 via-purple-500/20 to-pink-500/20"
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            />
          </div>
          {/* <motion.div
            className="absolute -bottom-2 -right-2 w-16 h-16 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center shadow-lg"
            animate={{ y: [-2, 2, -2] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <CheckCircle className="w-8 h-8 text-white" />
          </motion.div> */}
        </motion.div>

        <motion.div
          className="text-center mb-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {userData.basic.fullName}
          </h2>
          {/* <p className="text-gray-600 mb-1">Premium Member</p> */}
          <div className="flex items-center justify-center space-x-2 text-sm text-green-600">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span>Premium Member</span>
          </div>
        </motion.div>

        <motion.div
          className="w-full bg-white rounded-2xl p-6 shadow-lg border border-gray-100"
          variants={cardVariants}
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
            Quick Stats
          </h3>
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">47</p>
                <p className="text-sm text-gray-600">Books Created</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-50 rounded-full flex items-center justify-center">
                <Clock className="w-5 h-5 text-purple-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">23h</p>
                <p className="text-sm text-gray-600">Avg. Session</p>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>

      {/* Details Cards Section */}
      <div className="lg:col-span-2 space-y-6">
        {/* Contact Information Card */}
        <motion.div
          variants={cardVariants}
          className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-center space-x-4 mb-6">
            <motion.div
              className="p-3 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-2xl"
              whileHover={{ rotate: 5 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <User className="w-6 h-6 text-white" />
            </motion.div>
            <div>
              <h3 className="text-xl font-bold text-gray-900">
                Contact Information
              </h3>
              <p className="text-gray-600">
                Personal details and contact methods
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <motion.div
              className="group"
              whileHover={{ y: -2 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-2xl group-hover:bg-blue-50 transition-colors duration-200">
                <Mail className="w-5 h-5 text-blue-600" />
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Email Address
                  </label>
                  <p className="text-gray-900 font-medium">
                    {userData.basic.email}
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              className="group"
              whileHover={{ y: -2 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-2xl group-hover:bg-green-50 transition-colors duration-200">
                <Phone className="w-5 h-5 text-green-600" />
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Phone Number
                  </label>
                  <p className="text-gray-900 font-medium">
                    {userData.basic.phone}
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Address Information Card */}
        <motion.div
          variants={cardVariants}
          className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-center space-x-4 mb-6">
            <motion.div
              className="p-3 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-2xl"
              whileHover={{ rotate: -5 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <MapPin className="w-6 h-6 text-white" />
            </motion.div>
            <div>
              <h3 className="text-xl font-bold text-gray-900">
                Address Information
              </h3>
              <p className="text-gray-600">Shipping and billing addresses</p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <motion.div
              className="group"
              whileHover={{ y: -2 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="p-6 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100 group-hover:border-blue-200 transition-all duration-200">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                  <label className="text-sm font-semibold text-blue-700 uppercase tracking-wide">
                    Shipping Address
                  </label>
                </div>
                <p className="text-gray-900 whitespace-pre-line leading-relaxed">
                  {userData.basic.shippingAddress}
                </p>
              </div>
            </motion.div>

            <motion.div
              className="group"
              whileHover={{ y: -2 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="p-6 bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl border border-purple-100 group-hover:border-purple-200 transition-all duration-200">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                  <label className="text-sm font-semibold text-purple-700 uppercase tracking-wide">
                    Billing Address
                  </label>
                </div>
                <p className="text-gray-900 whitespace-pre-line leading-relaxed">
                  {userData.basic.billingAddress}
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Account Status Card */}
        <motion.div
          variants={cardVariants}
          className="bg-gradient-to-r from-orange-50 to-red-50 rounded-3xl p-8 shadow-lg border border-orange-100"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <motion.div
                className="p-3 bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl"
                animate={{ rotate: [0, 5, -5, 0] }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <Calendar className="w-6 h-6 text-white" />
              </motion.div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">
                  Account Status
                </h3>
                <p className="text-gray-600">Member since March 2023</p>
              </div>
            </div>
            <motion.div
              className="text-right"
              animate={{ scale: [1, 1.05, 1] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            >
              <p className="text-3xl font-bold text-orange-600">2.1</p>
              <p className="text-sm text-orange-600 font-medium">
                Years Active
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );

  const renderActivity = () => (
    <motion.div
      key="activity"
      variants={tabContentVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="space-y-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <motion.div
          variants={cardVariants}
          className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6 border border-purple-200"
        >
          <div className="flex items-center space-x-3 mb-3">
            <Calendar className="w-6 h-6 text-purple-600" />
            <h3 className="text-lg font-semibold text-purple-900">
              Account Created
            </h3>
          </div>
          <p className="text-2xl font-bold text-purple-900">
            {userData.activity.accountCreated}
          </p>
        </motion.div>

        <motion.div
          variants={cardVariants}
          className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 border border-blue-200"
        >
          <div className="flex items-center space-x-3 mb-3">
            <Clock className="w-6 h-6 text-blue-600" />
            <h3 className="text-lg font-semibold text-blue-900">Last Login</h3>
          </div>
          <p className="text-2xl font-bold text-blue-900">
            {userData.activity.lastLogin}
          </p>
        </motion.div>

        <motion.div
          variants={cardVariants}
          className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6 border border-orange-200"
        >
          <div className="flex items-center space-x-3 mb-3">
            <BookOpen className="w-6 h-6 text-orange-600" />
            <h3 className="text-lg font-semibold text-orange-900">
              Coloring Books
            </h3>
          </div>
          <p className="text-2xl font-bold text-orange-900">
            {userData.activity.coloringBooksCreated}
          </p>
          <p className="text-sm text-orange-700 mt-1">created</p>
        </motion.div>
      </div>

      <motion.div
        variants={cardVariants}
        className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
      >
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Activity Summary
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Total Sessions</span>
              <span className="font-medium text-gray-900">
                {userData.activity.totalSessions}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Average Session Time</span>
              <span className="font-medium text-gray-900">
                {userData.activity.averageSessionTime}
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );

  const renderPayments = () => (
    <motion.div
      key="payments"
      variants={tabContentVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="space-y-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <motion.div
          variants={cardVariants}
          className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 border border-green-200"
        >
          <div className="flex items-center space-x-3 mb-3">
            <DollarSign className="w-6 h-6 text-green-600" />
            <h3 className="text-lg font-semibold text-green-900">
              Payment Summary
            </h3>
          </div>
          <div className="space-y-3">
            <div>
              <p className="text-sm text-green-700">Last Payment</p>
              <p className="text-xl font-bold text-green-900">
                {userData.payments.lastPayment.amount}
              </p>
              <p className="text-sm text-green-700">
                {userData.payments.lastPayment.date}
              </p>
            </div>
            <div>
              <p className="text-sm text-green-700">Total Payments</p>
              <p className="text-2xl font-bold text-green-900">
                {userData.payments.totalPayments}
              </p>
            </div>
          </div>
        </motion.div>

        {/* <motion.div
          variants={cardVariants}
          className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Quick Actions
          </h3>
          <div className="space-y-3">
            <button className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-xl transition-colors duration-200">
              <Eye className="w-4 h-4" />
              <span>View All Invoices</span>
            </button>
            <button className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-red-50 hover:bg-red-100 text-red-700 rounded-xl transition-colors duration-200">
              <RefreshCw className="w-4 h-4" />
              <span>Process Refund</span>
            </button>
          </div>
        </motion.div> */}
      </div>
      <Transaction userId={id} />
      {/* <motion.div
        variants={cardVariants}
        className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
      >
        <div className="p-6 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">
            Transaction History
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date & Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Amount
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Payment Method
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Transaction ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {userData.payments.transactions.map((transaction, index) => (
                <motion.tr
                  key={transaction.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="hover:bg-gray-50 transition-colors duration-150"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div>
                      <div className="text-sm font-medium text-gray-900">
                        {transaction.date}
                      </div>
                      <div className="text-sm text-gray-500">
                        {transaction.time}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-medium text-gray-900">
                      {transaction.amount}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
                        transaction.status
                      )}`}
                    >
                      {getStatusIcon(transaction.status)}
                      <span>{transaction.status}</span>
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm text-gray-900">
                      {transaction.method}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-mono text-gray-500">
                      {transaction.stripeId}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex space-x-2">
                      <button className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors duration-150">
                        View
                      </button>
                      {transaction.status === "Success" && (
                        <button className="text-red-600 hover:text-red-800 text-sm font-medium transition-colors duration-150">
                          Refund
                        </button>
                      )}
                    </div>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div> */}
    </motion.div>
  );

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 p-6"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <div className="flex items-center space-x-4 mb-2">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center">
              <User className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                {userData.basic.fullName}
              </h1>
              <p className="text-gray-600">{userData.basic.email}</p>
            </div>
          </div>
        </motion.div>

        {/* Tab Navigation */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mb-8"
        >
          <div className="flex space-x-1 bg-gray-100 p-1 rounded-2xl w-fit">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`relative flex items-center space-x-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                    activeTab === tab.id
                      ? "text-white shadow-lg"
                      : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  {activeTab === tab.id && (
                    <motion.div
                      layoutId="activeTab"
                      className="absolute inset-0 bg-gradient-to-r from-[#ef427c] to-[#feb1d5] rounded-xl

"
                      transition={{
                        type: "spring",
                        bounce: 0.2,
                        duration: 0.6,
                      }}
                    />
                  )}
                  <Icon className="w-4 h-4 relative z-10" />
                  <span className="relative z-10">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </motion.div>

        {/* Tab Content */}
        <AnimatePresence mode="wait">
          {activeTab === "basic" && renderBasicDetails()}
          {activeTab === "activity" && renderActivity()}
          {activeTab === "payments" && renderPayments()}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default UserDetailsPage;
